import React, {useState} from 'react';
import {PriceFilterConfig} from '../../typing/main';
import {FilterPriceTranslation} from '../../typing/translations';
import {getStepsByRange} from '../../utils/general';
import FilterContentLabel from '../filter-content-label';
import RangeSlider from '../range-slider';
import {
  StyledFilterPriceContainer,
  StyledFilterPriceSliderContainer,
} from './styles';

interface FilterPriceProps {
  translation: FilterPriceTranslation;
  onChangeUserPrice: (value: number[]) => void;
  onHandleRangeCommitted: () => void;
  currentPrice: number[];
  config: PriceFilterConfig;
  isMobile: boolean;
}

const FilterPrice: React.FC<FilterPriceProps> = ({
  translation,
  onChangeUserPrice,
  currentPrice,
  onHandleRangeCommitted,
  config: price,
  isMobile
}) => {
  const [hideOptions, setHideOptions] = useState(false);
  const formatPriceNumber = (number: number) =>
    price?.currencySymbol +
    number.toLocaleString() +
    `${number === price.maxDistance ? '+' : ''}`;

  const onHandleRangeChange = (
    _: React.ChangeEvent<{}>,
    newValue: number | number[],
    activeThumb: number,
  ) => {
    if (!newValue || !newValue[0] || !newValue[1]) return;
    const minDistance = price.step;
    let processedValue = newValue as number[];
    if (!Array.isArray(newValue)) {
      return;
    }

    // processing overrank values
    if (newValue[0] < price.minDistance) {
      newValue[0] = price.minDistance;
    }
    if (newValue[1] > price.maxDistance) {
      newValue[1] = price.maxDistance;
    }

    if (newValue[1] - newValue[0] < minDistance) {
      if (activeThumb === 0) {
        const clamped = Math.max(newValue[0], price.maxDistance - minDistance);
        processedValue = [clamped, clamped + minDistance];
      } else {
        let clamped = Math.min(newValue[1], price.maxDistance);
        if (clamped <= price.minDistance) {
          clamped = price.minDistance + minDistance;
        }
        processedValue = [clamped - minDistance, clamped];
      }
    }

    onChangeUserPrice(processedValue);
  };

  return (
    <StyledFilterPriceContainer className="filter-price_container">
      <FilterContentLabel
        label={translation.label}
        hideOptions={hideOptions}
        setHideOptions={setHideOptions}
        isMobile={isMobile}
      />
      {(hideOptions && isMobile) || !isMobile ? (
        <StyledFilterPriceSliderContainer id="discrete-slider-small-steps">
          <RangeSlider
            aria-labelledby="discrete-slider-small-steps"
            step={price.step}
            min={(price.minDistance || 0) - (price?.step || 0)}
            max={(price.maxDistance || 0) + (price?.step || 0)}
            onChange={onHandleRangeChange}
            onChangeCommitted={onHandleRangeCommitted}
            value={currentPrice.length ? currentPrice : price.default}
            valueLabelFormat={formatPriceNumber}
            className="price-container"
            valueLabelDisplay={price?.markDisplay || 'auto'}
            disableSwap={true}
            marks={getStepsByRange(
              10,
              price.step,
              price.minDistance,
              price.maxDistance,
              formatPriceNumber,
              2,
            )}
          />
        </StyledFilterPriceSliderContainer>
      ): null}
    </StyledFilterPriceContainer>
  );
};

export default FilterPrice;
